"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Menu = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? theme_1.colors.black : _b, rest = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ width: "42px", height: "42px", viewBox: "0 0 42 42", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, rest),
        React.createElement("g", { id: "Icon/Mobile-Menu" },
            React.createElement("g", { id: "Mask-Mobile-Menu", transform: "translate(5.250000, 8.750000)", fill: fill },
                React.createElement("path", { d: "M5.25,2.625 C5.25,4.074 4.074,5.25 2.625,5.25 C1.176,5.25 0,4.074 0,2.625 C0,1.176 1.176,0 2.625,0 C4.074,0 5.25,1.176 5.25,2.625", id: "Fill-1-Mobile-Menu" }),
                React.createElement("path", { d: "M5.25,11.375 C5.25,12.824 4.074,14 2.625,14 C1.176,14 0,12.824 0,11.375 C0,9.926 1.176,8.75 2.625,8.75 C4.074,8.75 5.25,9.926 5.25,11.375", id: "Fill-3-Mobile-Menu" }),
                React.createElement("path", { d: "M5.25,20.125 C5.25,21.574 4.074,22.75 2.625,22.75 C1.176,22.75 0,21.574 0,20.125 C0,18.676 1.176,17.5 2.625,17.5 C4.074,17.5 5.25,18.676 5.25,20.125", id: "Fill-5-Mobile-Menu" }),
                React.createElement("path", { d: "M28.25,5.25 L12,5.25 C10.206,5.25 8.75,4.074 8.75,2.625 C8.75,1.176 10.206,0 12,0 L28.25,0 C30.044,0 31.5,1.176 31.5,2.625 C31.5,4.074 30.044,5.25 28.25,5.25", id: "Fill-7-Mobile-Menu" }),
                React.createElement("path", { d: "M28.25,14 L12,14 C10.206,14 8.75,12.824 8.75,11.375 C8.75,9.926 10.206,8.75 12,8.75 L28.25,8.75 C30.044,8.75 31.5,9.926 31.5,11.375 C31.5,12.824 30.044,14 28.25,14", id: "Fill-9-Mobile-Menu" }),
                React.createElement("path", { d: "M28.25,22.75 L12,22.75 C10.206,22.75 8.75,21.574 8.75,20.125 C8.75,18.676 10.206,17.5 12,17.5 L28.25,17.5 C30.044,17.5 31.5,18.676 31.5,20.125 C31.5,21.574 30.044,22.75 28.25,22.75", id: "Fill-11-Mobile-Menu" })))));
};
exports.Menu = Menu;
//# sourceMappingURL=Menu.js.map